/* ============================================================
   Retaining Wall Calculator — rw-calculator.js  v2
   ============================================================ */

(function () {
  'use strict';

  // ── State ──────────────────────────────────────────────────
  var state = {
    finish: null,    // 'stackstone' | 'corten' | 'limestone' | 'brick'
    shape:  null,    // 'straight' | 'l-shape' | 'u-shape' | 'custom'
    capQtyPyramidal:  0,
    capQtyBallFinial: 0,
    legA: 0,
    legB: 0,
    legC: 0
  };

  // ── Calculated quantities ──────────────────────────────────
  var calc = {
    panels: 0,
    inlinePosts: 0,
    cornerPosts: 0,
    totalPosts: 0
  };

  // ── Helpers ────────────────────────────────────────────────
  function fmt(n) {
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function show(el) {
    if (el) el.classList.remove('rw-section--hidden');
  }
  function hide(el) {
    if (el) el.classList.add('rw-section--hidden');
  }

  function isCortenFinish() {
    return state.finish === 'corten';
  }

  // posts are always standard (limestone) except for corten finish
  function getPostSet() {
    return isCortenFinish() ? 'corten' : 'standard';
  }

  function getCapSet() {
    return isCortenFinish() ? 'corten' : 'standard';
  }

  // ── Hero image swap ────────────────────────────────────────
  var FINISH_LABELS = {
    stackstone: 'Stackstone',
    corten:     'Corten Steel',
    limestone:  'Limestone',
    brick:      'Brickyard'
  };

  function swapHeroImage(finish) {
    var img   = document.getElementById('rw-hero-img');
    var label = document.getElementById('rw-image-label');
    if (!img) return;

    var images = window.rwProductData && window.rwProductData.images;
    var newSrc = images && images[finish] ? images[finish] : (images && images['default']);
    if (!newSrc) return;

    // fade out
    img.classList.add('rw-img-fade');

    setTimeout(function () {
      img.src = newSrc;
      img.alt = 'HomeBridge GFRC Retaining Wall — ' + (FINISH_LABELS[finish] || finish);
      if (label) {
        label.textContent = FINISH_LABELS[finish] || finish;
      }
      // fade back in (next tick so browser registers the class before removing)
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          img.classList.remove('rw-img-fade');
        });
      });
    }, 220); // matches CSS transition duration
  }

  // ── Calculation ────────────────────────────────────────────
  function panelsForLeg(feet) {
    if (!feet || feet <= 0) return 0;
    return Math.ceil(feet / 4);
  }

  function runCalculation() {
    var data = window.rwProductData;
    var shape = state.shape;
    var legA = state.legA;
    var legB = state.legB;
    var legC = state.legC;
    var corners = 0;
    var panels = 0;

    if (shape === 'straight') {
      panels = panelsForLeg(legA);
      corners = 0;
    } else if (shape === 'l-shape') {
      panels = panelsForLeg(legA) + panelsForLeg(legB);
      corners = 1;
    } else if (shape === 'u-shape') {
      panels = panelsForLeg(legA) + panelsForLeg(legB) + panelsForLeg(legC);
      corners = 2;
    }

    var totalPosts = panels + 1;
    var cornerPosts = corners;
    var inlinePosts = totalPosts - cornerPosts;

    calc.panels = panels;
    calc.totalPosts = totalPosts;
    calc.inlinePosts = inlinePosts;
    calc.cornerPosts = cornerPosts;

    // prices
    var panelPrice   = data.panels[state.finish].price;
    var postPrice    = data.posts[getPostSet()].inline.price;
    var capPrice     = data.caps[getCapSet()].pyramidal.price; // same price both styles
    var pipePrice    = data.pipe.price;
    var mandrelPrice = data.mandrel.price;

    var qtyPyramidal  = state.capQtyPyramidal;
    var qtyBallFinial = state.capQtyBallFinial;

    var subPanels    = panels * panelPrice;
    var subInline    = inlinePosts * postPrice;
    var subCorner    = cornerPosts * postPrice;
    var subCapsPyr   = qtyPyramidal  * capPrice;
    var subCapsBall  = qtyBallFinial * capPrice;
    var subPipes     = totalPosts * pipePrice;
    var total        = subPanels + subInline + subCorner + subCapsPyr + subCapsBall + subPipes + mandrelPrice;

    var shapeNames = {
      'straight': 'Straight Wall',
      'l-shape':  'L-Shape',
      'u-shape':  'U-Shape'
    };

    document.getElementById('rw-finish-label').textContent = '— ' + (FINISH_LABELS[state.finish] || state.finish);

    // Update unit price cells (caps vary by finish: standard vs corten)
    var fmtUnit = function(p) { return '$' + p.toFixed(2); };
    var panelUnitEl = document.getElementById('rw-unit-panels');
    var postUnitEl  = document.getElementById('rw-unit-posts');
    var postCrnUnitEl = document.getElementById('rw-unit-posts-corner');
    var capPyrUnitEl  = document.getElementById('rw-unit-caps-pyramidal');
    var capBallUnitEl = document.getElementById('rw-unit-caps-ballfinial');
    if (panelUnitEl)  panelUnitEl.textContent  = fmtUnit(panelPrice);
    if (postUnitEl)   postUnitEl.textContent   = fmtUnit(postPrice);
    if (postCrnUnitEl) postCrnUnitEl.textContent = fmtUnit(postPrice);
    if (capPyrUnitEl)  capPyrUnitEl.textContent  = fmtUnit(capPrice);
    if (capBallUnitEl) capBallUnitEl.textContent  = fmtUnit(capPrice);

    document.getElementById('rw-qty-panels').textContent  = panels;
    document.getElementById('rw-qty-inline').textContent  = inlinePosts;
    document.getElementById('rw-qty-corner').textContent  = cornerPosts;
    document.getElementById('rw-qty-pipes').textContent   = totalPosts;

    // Cap rows — show/hide based on qty
    var pyrRow  = document.getElementById('rw-row-caps-pyramidal');
    var ballRow = document.getElementById('rw-row-caps-ballfinial');
    if (qtyPyramidal > 0) {
      document.getElementById('rw-qty-caps-pyramidal').textContent  = qtyPyramidal;
      document.getElementById('rw-sub-caps-pyramidal').textContent  = fmt(subCapsPyr);
      show(pyrRow);
    } else {
      hide(pyrRow);
    }
    if (qtyBallFinial > 0) {
      document.getElementById('rw-qty-caps-ballfinial').textContent  = qtyBallFinial;
      document.getElementById('rw-sub-caps-ballfinial').textContent  = fmt(subCapsBall);
      show(ballRow);
    } else {
      hide(ballRow);
    }

    document.getElementById('rw-sub-panels').textContent  = fmt(subPanels);
    document.getElementById('rw-sub-inline').textContent  = fmt(subInline);
    document.getElementById('rw-sub-corner').textContent  = fmt(subCorner);
    document.getElementById('rw-sub-pipes').textContent   = fmt(subPipes);
    document.getElementById('rw-total').textContent       = fmt(total);

    // Hide corner row if 0 corners
    var cornerRow = document.getElementById('rw-row-corner');
    if (cornerPosts === 0) {
      hide(cornerRow);
    } else {
      show(cornerRow);
    }

    // Description
    var desc = shapeNames[shape];
    if (shape === 'straight') {
      desc += ' — ' + legA + ' ft';
    } else if (shape === 'l-shape') {
      desc += ' — ' + legA + ' ft × ' + legB + ' ft';
    } else if (shape === 'u-shape') {
      desc += ' — ' + legA + ' ft / ' + legB + ' ft / ' + legC + ' ft';
    }
    document.getElementById('rw-results-desc').textContent = desc;
  }

  // ── Add to Cart ────────────────────────────────────────────
  function buildCartItems() {
    var data = window.rwProductData;
    var postSet = getPostSet();
    var capSet  = getCapSet();
    var items = [];

    // Panels
    if (calc.panels > 0) {
      items.push({ id: data.panels[state.finish].variantId, quantity: calc.panels });
    }
    // Inline posts
    if (calc.inlinePosts > 0) {
      items.push({ id: data.posts[postSet].inline.variantId, quantity: calc.inlinePosts });
    }
    // Corner posts
    if (calc.cornerPosts > 0) {
      items.push({ id: data.posts[postSet].corner.variantId, quantity: calc.cornerPosts });
    }
    // Caps — add each style separately if qty > 0
    if (state.capQtyPyramidal > 0) {
      items.push({ id: data.caps[capSet].pyramidal.variantId, quantity: state.capQtyPyramidal });
    }
    if (state.capQtyBallFinial > 0) {
      items.push({ id: data.caps[capSet].ballfinial.variantId, quantity: state.capQtyBallFinial });
    }
    // Pipes
    if (calc.totalPosts > 0) {
      items.push({ id: data.pipe.variantId, quantity: calc.totalPosts });
    }
    // Mandrel — always 1
    items.push({ id: data.mandrel.variantId, quantity: 1 });

    return items;
  }

  function doAddToCart() {
    var btn = document.getElementById('rw-atc-btn');
    var status = document.getElementById('rw-atc-status');
    btn.disabled = true;
    btn.textContent = 'Adding to Cart…';
    status.textContent = '';
    status.className = 'rw-atc-status';

    var items = buildCartItems();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Cart error ' + res.status);
      return res.json();
    })
    .then(function() {
      status.textContent = 'All items added! Heading to your cart…';
      status.className = 'rw-atc-status rw-atc-status--success';
      btn.textContent = 'Add Everything to Cart';
      btn.disabled = false;
      setTimeout(function() {
        window.location.href = '/cart';
      }, 1200);
    })
    .catch(function(err) {
      console.error('RW ATC error:', err);
      status.textContent = 'Something went wrong. Please try again.';
      status.className = 'rw-atc-status rw-atc-status--error';
      btn.textContent = 'Add Everything to Cart';
      btn.disabled = false;
    });
  }

  // ── Dimension validation & live update ────────────────────
  function getDimensions() {
    state.legA = parseFloat(document.getElementById('rw-input-legA').value) || 0;
    state.legB = parseFloat(document.getElementById('rw-input-legB').value) || 0;
    state.legC = parseFloat(document.getElementById('rw-input-legC').value) || 0;
  }

  function dimsValid() {
    var shape = state.shape;
    if (shape === 'straight') return state.legA >= 4;
    if (shape === 'l-shape')  return state.legA >= 4 && state.legB >= 4;
    if (shape === 'u-shape')  return state.legA >= 4 && state.legB >= 4 && state.legC >= 4;
    return false;
  }

  // ── Cap qty tally ──────────────────────────────────────────
  function updateCapTally() {
    var needed  = calc.totalPosts;
    var assigned = state.capQtyPyramidal + state.capQtyBallFinial;
    var tallyEl  = document.getElementById('rw-cap-tally');
    var tallyTxt = document.getElementById('rw-cap-tally-text');
    if (!tallyEl || !tallyTxt) return;

    if (needed === 0) { tallyEl.className = 'rw-cap-tally'; tallyTxt.textContent = ''; return; }

    if (assigned === needed) {
      tallyEl.className = 'rw-cap-tally rw-cap-tally--ok';
      tallyTxt.textContent = '\u2713 ' + assigned + ' of ' + needed + ' caps assigned';
    } else if (assigned < needed) {
      tallyEl.className = 'rw-cap-tally rw-cap-tally--under';
      tallyTxt.textContent = assigned + ' of ' + needed + ' caps assigned — ' + (needed - assigned) + ' still unassigned';
    } else {
      tallyEl.className = 'rw-cap-tally rw-cap-tally--over';
      tallyTxt.textContent = assigned + ' of ' + needed + ' caps assigned — ' + (assigned - needed) + ' over recommended';
    }
  }

  function getCapQtys() {
    var pyrEl  = document.getElementById('rw-input-cap-pyramidal');
    var ballEl = document.getElementById('rw-input-cap-ballfinial');
    state.capQtyPyramidal  = pyrEl  ? (parseInt(pyrEl.value,  10) || 0) : 0;
    state.capQtyBallFinial = ballEl ? (parseInt(ballEl.value, 10) || 0) : 0;
  }

  function tryShowResults() {
    getDimensions();
    if (!dimsValid()) {
      hide(document.getElementById('rw-step-cap'));
      hide(document.getElementById('rw-results'));
      return;
    }
    // Recalculate totals first so we know totalPosts
    var data = window.rwProductData;
    var shape = state.shape;
    var corners = shape === 'u-shape' ? 2 : shape === 'l-shape' ? 1 : 0;
    var panels = 0;
    if (shape === 'straight') panels = panelsForLeg(state.legA);
    else if (shape === 'l-shape')  panels = panelsForLeg(state.legA) + panelsForLeg(state.legB);
    else if (shape === 'u-shape')  panels = panelsForLeg(state.legA) + panelsForLeg(state.legB) + panelsForLeg(state.legC);
    calc.panels      = panels;
    calc.totalPosts  = panels + 1;
    calc.cornerPosts = corners;
    calc.inlinePosts = calc.totalPosts - corners;

    // Default pyramidal to full qty, ballfinial to 0 on first show
    var pyrEl  = document.getElementById('rw-input-cap-pyramidal');
    var ballEl = document.getElementById('rw-input-cap-ballfinial');
    var needsEl = document.getElementById('rw-cap-total-needed');
    if (needsEl) needsEl.textContent = calc.totalPosts;

    // Only reset defaults if both are still 0 (fresh step reveal)
    if (pyrEl && ballEl && parseInt(pyrEl.value,10) === 0 && parseInt(ballEl.value,10) === 0) {
      pyrEl.value  = calc.totalPosts;
      ballEl.value = 0;
    }
    // If totalPosts changed (user went back and changed dims), re-default
    if (pyrEl && ballEl) {
      var prev = parseInt(pyrEl.getAttribute('data-prev-total') || '0', 10);
      if (prev !== calc.totalPosts) {
        pyrEl.value  = calc.totalPosts;
        ballEl.value = 0;
        pyrEl.setAttribute('data-prev-total', calc.totalPosts);
      }
    }

    show(document.getElementById('rw-step-cap'));
    getCapQtys();
    updateCapTally();
    runCalculation();
    show(document.getElementById('rw-results'));
  }

  // ── Reset ──────────────────────────────────────────────────
  function resetAll() {
    state.finish = null;
    state.shape = null;
    state.capQtyPyramidal  = 0;
    state.capQtyBallFinial = 0;
    state.legA = state.legB = state.legC = 0;

    // Reset button states
    document.querySelectorAll('.rw-finish-btn').forEach(function(b) {
      b.setAttribute('aria-pressed', 'false');
    });
    document.querySelectorAll('.rw-shape-btn').forEach(function(b) {
      b.setAttribute('aria-pressed', 'false');
    });

    // Reset cap inputs
    var pyrEl  = document.getElementById('rw-input-cap-pyramidal');
    var ballEl = document.getElementById('rw-input-cap-ballfinial');
    if (pyrEl)  { pyrEl.value  = 0; pyrEl.removeAttribute('data-prev-total'); }
    if (ballEl) { ballEl.value = 0; }
    var needsEl = document.getElementById('rw-cap-total-needed');
    if (needsEl) needsEl.textContent = '—';
    var tallyEl = document.getElementById('rw-cap-tally');
    var tallyTxt = document.getElementById('rw-cap-tally-text');
    if (tallyEl)  tallyEl.className = 'rw-cap-tally';
    if (tallyTxt) tallyTxt.textContent = '';

    // Clear inputs
    ['rw-input-legA','rw-input-legB','rw-input-legC'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.value = '';
    });

    // Show only step 1, hide rest
    show(document.getElementById('rw-step-finish'));
    hide(document.getElementById('rw-step-shape'));
    hide(document.getElementById('rw-step-dimensions'));
    hide(document.getElementById('rw-dim-legB'));
    hide(document.getElementById('rw-dim-legC'));
    hide(document.getElementById('rw-step-cap'));
    hide(document.getElementById('rw-results'));
    hide(document.getElementById('rw-custom-cta'));

    // Reset hero image to default
    var img   = document.getElementById('rw-hero-img');
    var label = document.getElementById('rw-image-label');
    var images = window.rwProductData && window.rwProductData.images;
    if (img && images) {
      img.classList.add('rw-img-fade');
      setTimeout(function () {
        img.src = images['default'] || images['stackstone'];
        img.alt = 'HomeBridge GFRC Retaining Wall';
        if (label) label.textContent = 'Choose a finish to preview';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            img.classList.remove('rw-img-fade');
          });
        });
      }, 220);
    }

    // Clear status
    var status = document.getElementById('rw-atc-status');
    if (status) { status.textContent = ''; status.className = 'rw-atc-status'; }

    window.scrollTo({ top: document.getElementById('rw-calc').offsetTop - 20, behavior: 'smooth' });
  }

  // ── Init ──────────────────────────────────────────────────
  function init() {
    var calc_el = document.getElementById('rw-calc');
    if (!calc_el) return;

    // Finish buttons
    document.querySelectorAll('.rw-finish-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        state.finish = this.dataset.finish;
        document.querySelectorAll('.rw-finish-btn').forEach(function(b) {
          b.setAttribute('aria-pressed', 'false');
        });
        this.setAttribute('aria-pressed', 'true');

        // ── Swap hero image for selected finish ──
        swapHeroImage(state.finish);

        show(document.getElementById('rw-step-shape'));
        hide(document.getElementById('rw-step-dimensions'));
        hide(document.getElementById('rw-step-cap'));
        hide(document.getElementById('rw-results'));
        hide(document.getElementById('rw-custom-cta'));
        // Reset shape selection
        state.shape = null;
        document.querySelectorAll('.rw-shape-btn').forEach(function(b) {
          b.setAttribute('aria-pressed', 'false');
        });
        document.getElementById('rw-step-shape').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });

    // Shape buttons
    document.querySelectorAll('.rw-shape-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        state.shape = this.dataset.shape;
        document.querySelectorAll('.rw-shape-btn').forEach(function(b) {
          b.setAttribute('aria-pressed', 'false');
        });
        this.setAttribute('aria-pressed', 'true');

        hide(document.getElementById('rw-custom-cta'));
        hide(document.getElementById('rw-results'));
        hide(document.getElementById('rw-step-cap'));

        if (state.shape === 'custom') {
          hide(document.getElementById('rw-step-dimensions'));
          show(document.getElementById('rw-custom-cta'));
          document.getElementById('rw-custom-cta').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return;
        }

        // Show/hide leg inputs based on shape
        show(document.getElementById('rw-step-dimensions'));
        show(document.getElementById('rw-dim-legA'));

        if (state.shape === 'l-shape' || state.shape === 'u-shape') {
          show(document.getElementById('rw-dim-legB'));
        } else {
          hide(document.getElementById('rw-dim-legB'));
          document.getElementById('rw-input-legB').value = '';
        }

        if (state.shape === 'u-shape') {
          show(document.getElementById('rw-dim-legC'));
        } else {
          hide(document.getElementById('rw-dim-legC'));
          document.getElementById('rw-input-legC').value = '';
        }

        // Update label for Leg A context
        var legALabel = document.getElementById('rw-label-legA');
        if (legALabel) {
          legALabel.textContent = state.shape === 'straight' ? 'Wall Length — Linear feet' : 'Leg A — Linear feet';
        }

        document.getElementById('rw-step-dimensions').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        tryShowResults();
      });
    });

    // Dimension inputs — live update
    ['rw-input-legA','rw-input-legB','rw-input-legC'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', tryShowResults);
    });

    // Cap qty +/- buttons
    document.querySelectorAll('.rw-cap-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var targetId = this.getAttribute('data-target');
        var delta    = parseInt(this.getAttribute('data-delta'), 10);
        var input    = document.getElementById(targetId);
        if (!input) return;
        var newVal = Math.max(0, (parseInt(input.value, 10) || 0) + delta);
        input.value = newVal;
        getCapQtys();
        updateCapTally();
        if (dimsValid()) runCalculation();
      });
    });

    // Cap qty direct input
    ['rw-input-cap-pyramidal', 'rw-input-cap-ballfinial'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('input', function() {
        getCapQtys();
        updateCapTally();
        if (dimsValid()) runCalculation();
      });
    });

    // ATC button
    var atcBtn = document.getElementById('rw-atc-btn');
    if (atcBtn) atcBtn.addEventListener('click', doAddToCart);

    // Restart buttons
    ['rw-restart-btn','rw-restart-btn-custom'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('click', resetAll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
